import { Modal } from "react-bootstrap";
import Video from "../Video/Video"; 

export default function BenchModal({ showModal, setShowModal, selectedVideo }) {
    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="text-center w-100">{selectedVideo?.title || 'Bench Video'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                {selectedVideo && (
                    <Video
                        _id={selectedVideo._id}
                        title={selectedVideo.title}
                        url={selectedVideo.url}
                        reactions={selectedVideo.reactions || []}
                        className="video-modal"
                        hideTitle={true}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
}
